// extracted by mini-css-extract-plugin
export default {"preFormFooterButton":"style_preFormFooterButton__Np208","disabledButton":"style_disabledButton__df7ik"};